module.exports = __webpack_public_path__ + "static/media/mapMarker.2a7546b9.svg";